import React from 'react'
import Particle from 'react-particles-js';
import styled from 'styled-components';
import { Facebook, GitHub, YouTube } from "@material-ui/icons";


function HomePage() {
    return (
        <HomePageStyled>
            <div className="particle-con">
                <Particle />
            </div>
            <div className="typography">
                <h1>Hi I'm<span>Manik Kumar Shil</span></h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut nostrum, perferendis, quo necessitatibus unde placeat ipsum odio magni similique reprehenderit id dicta itaque. Minus, natus facilis repudiandae sit nesciunt aliquid.</p>
            <div className="icons">
                <a href="https://www.facebook.com/" className="icon i-facebook"><Facebook/></a>
                <a href="https://www.youtube.com/" className="icon i-youtube"><YouTube /></a>
                <a href="https://www.github.com/" className="icon i-github"><GitHub/></a>
               
            </div>
            </div>
            
        </HomePageStyled>
    );
};

const HomePageStyled = styled.header`
 width: 100%;
 height: 100vh;
 position: relative; 

 /* .p-particles-js{
     position: absolute;
     top: 0;
     left: 0;

 } */
 
.typography{
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  text-align:center;
  width: 80%;
  
.icons{
    display:flex;
        align-items: center;
        justify-content: center;
        margin-top: 1rem;

   
    .icon{
        border:2px solid var(--border-color);
        display:flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all .4s ease-in-out;
        cursor: pointer;

        &:hover{
            border:2px solid var(--primary-color);
            color:var(--primary-color);

        }
        &:not(:last-child){
          
            margin-right: 1rem;
  

        }

        svg{
            margin: 0.5rem;

        }

    }

.i-youtube{
    &:hover{
        border:2px solid red;
        color:red;
    }
}
.i-github{
    &:hover{
        border:2px solid purple;
        color:purple;

    }
}

}
}


`;


export default HomePage;
